export default "__VITE_ASSET__aadf8450__"